import { render, staticRenderFns } from "./OtherExpenseDetail.vue?vue&type=template&id=028ca3e7&"
import script from "./OtherExpenseDetail.vue?vue&type=script&lang=js&"
export * from "./OtherExpenseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports